import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { AppStoreContext } from "../stores/AppStore";
import { Button, Card, CardContent, CardHeader } from "semantic-ui-react";
import { GLGIcon } from "./GLGIcon";
import { post } from "../lib/http";
import { GLOBAL_MODALS } from "../stores/modals";

export default observer(function CMExists() {
  const [t] = useTranslation();
  const appStore = useContext(AppStoreContext);
  const [accessGranted, setAccessGranted] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const { isDNC } = appStore;

  const requestAccessLink = () => {
    setIsBusy(true);
    post("api/requestAccessLink", {
      emailAddress: appStore.emailAddress,
      phoneNumber: appStore.phoneNumber,
      locale: appStore.locale,
      linkBack: true // makes it like back to cm-onboarding
    })
      .then((result) => {
        setAccessGranted(true);
        setIsBusy(false);
        appStore.emailAddress = result.emailSentTo
      })
      .catch(() => {
        setIsBusy(false);
        appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR;
      });
  };

  if (isDNC) {
    return (
      <div className="view view-container">
        <Card fluid style={{ padding: 20 }}>
          <CardContent>
            <CardHeader>{t("already_member")}</CardHeader>
          </CardContent>
          <CardContent>
            <p>
              <GLGIcon name={"id-7"} size="huge" />
            </p>
            <p dangerouslySetInnerHTML={{ __html: t("already_dnc") }} />
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="view view-container">
      <Card fluid style={{ padding: 20 }}>
        <CardContent>
          <CardHeader>{t("already_member")}</CardHeader>
        </CardContent>
        <CardContent>
          <p dangerouslySetInnerHTML={{ __html: t("already_council_member_text") }} />
          <div style={{ marginTop: 30 }}>
            {accessGranted ? (
              <strong>
                {t("access_granted_notice", {emailAddress: appStore.emailAddress})}
              </strong>
            ) : (
              <Button
                onClick={requestAccessLink}
                primary
                disabled={isBusy}
                loading={isBusy}
              >
                {t("log_your_account")}
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
});
